import React, { useCallback, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";

import Icon from "../assets/icons/Icon";
import { CommonModal, ConfimationModal, SettingCreate } from "../Modal";
import { deleteAxios, getAxios, postAxios } from "../Services/commonService";
import {
  API_BADLA_SETTING_LIST,
  API_BADLA_SETTING_DELETE,
} from "../utils/api/ApiConstant";
import { DataTable, SubHeading } from "../Components";

const BadlaSetting = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(50);
  const [searchTerm, setSearchTerm] = useState("");
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });

  const { isLoading, data: badlaSettingData } = useQuery({
    queryKey: [
      "badlaSettingData",
      currentPage,
      recordsPerPage,
      searchTerm,
      isShow.apiFlag,
    ],
    queryFn: async () =>
      await getAxios({
        url: API_BADLA_SETTING_LIST,
        params: {
          page: currentPage,
          limit: recordsPerPage,
          search: searchTerm,
        },
      }),
  });

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleRecordsperPage = useCallback((value) => {
    setRecordsPerPage(value);
  }, []);

  const handleSearch = useCallback((value) => {
    setSearchTerm(value);
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "action",
        header: "action",
        cell: ({ row }) => {
          const handleUpdateModal = useCallback(({ rowData }) => {
            setIsShow({
              isOpen: true,
              rowData,
              name: "edit",
              modalTitle: "Edit Setting",
              modalContent: SettingCreate,
            });
          });

          return (
            <div className="d-flex">
              <Icon
                name="MdEdit"
                className="m-1"
                title="Edit"
                onClick={() => handleUpdateModal({ rowData: row?.original })}
              />

              <ConfimationModal
                isIcon={true}
                iconName="MdDelete"
                getValue={row?.original?.isAutomatic}
                onStatusChange={() =>
                  handleDeleteRequest({
                    rowData: row?.original,
                  })
                }
              />
            </div>
          );
        },
      },
      {
        accessorKey: "settingName",
        header: "Setting Name",
      },
      {
        accessorKey: "remark",
        header: "Remark",
      },
      {
        accessorKey: "defaultValue",
        header: "Default Value",
      },
    ],
    []
  );

  const fetchData = useCallback(() => {
    if (!badlaSettingData) return { data: [], pages: 0 };

    return {
      data: badlaSettingData.docs,
      pages: badlaSettingData.totalPages,
    };
  }, [badlaSettingData]);

  const handleDeleteRequest = async ({ rowData }) => {
    const costumUrl = `${API_BADLA_SETTING_DELETE}/${rowData?._id}`;

    const res = await deleteAxios({
      url: costumUrl,
      payload: {},
    });

    if (res) {
      setIsShow((prev) => ({
        ...prev,
        apiFlag: !prev.apiFlag,
      }));
    }
  };

  return (
    <>
      <SubHeading
        subTitle="Badla Setting"
        isAddBtn={true}
        handleShowHide={() =>
          setIsShow((prev) => ({
            ...prev,
            isOpen: true,
            rowData: {},
            name: "add",
            modalTitle: "Add Setting",
            modalContent: SettingCreate,
          }))
        }
      />

      <div className="card-body">
        <DataTable
          columns={columns}
          fetchData={fetchData}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onRecordsPerPageChange={handleRecordsperPage}
          recordsPerPage={recordsPerPage}
          onSearchChange={handleSearch}
          isLoading={isLoading}
          isIndexing={true}
          isCheckBox={false}
          handleSearchKey={setIsShow}
        />
      </div>

      {isShow.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          handleShowHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleShowHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                  apiFlag: !prev.apiFlag,
                })),
              rowData: isShow.rowData,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default BadlaSetting;
